/** 禁止页面滚动  */
export const disableBodyScroll = () => {
  document.body.style.overflow = 'hidden';
};

/** 允许页面滚动 */
export const enableBodyScroll = () => {
  document.body.style.overflow = 'auto';
};
